import React, { useState, useEffect } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
  Navigate,
} from 'react-router-dom';
import Dashboard from './Pages/Dashboard/Dashboard';
import Conversations from './Pages/Message/Conversations';
import Documents from './Pages/Documents/Documents';
import NotFound from './Pages/NotFound';
import Login from './Pages/Login/Login';
import ForgotPassword from './Pages/Login/ForgotPassword';
import ResetPassword from './Pages/Login/ResetPassword';
import Roster from './Pages/Roster/Roster';
import RosterDetail from './Pages/Roster/RosterDetail';
import Irs from './Pages/Irs/Irs';
import IrsDetail from './Pages/Irs/IrsDetail';
import Training from './Pages/Training/Training';
import TrainingCreate from './Pages/Training/TrainingCreate';
import ReleaseNotes from './Pages/Releases/ReleaseNotes';
import { Grid } from '@mui/material';
import Footer from './Footer';
import TrainingDetail from './Pages/Training/TrainingDetail';
import Donations from './Pages/Donations/public/Donations';
import UserList from './Pages/Users/UserList';
import { applications } from './utils/variables';
import LCChapterList from './Pages/Chapters/LocalChapter/LCChapterList';
import SPDChapterList from './Pages/Chapters/SPDChapter/SPDChapterList';
import BnBList from './Pages/BedAndBreakfast/BnBList';
import BnBCreate from './Pages/BedAndBreakfast/BnBCreate';
import DonationsList from './Pages/Donations/internal/DonationsList';
import ReciprocityDetail from './Pages/Chapters/Reciprocities/ReciprocityDetail';
import ReciprocityList from './Pages/Chapters/Reciprocities/ReciprocityList';
import TLCList from './Pages/TLC/TLCList';
import ELFLanding from './Pages/Projects/ELF';
import StarLandingPage from './Pages/Projects/Star';
import PCELandingPage from './Pages/Projects/PCE';
import PSALandingPage from './Pages/Projects/PSA';
import IPSLandingPage from './Pages/Projects/IPS';
import FoundationLandingPage from './Pages/Projects/Foundation';
import {
  MarketplaceList,
  MarketplaceDetail,
  MarketplaceCreate,
  MarketplaceEdit,
} from './Pages/Marketplace';
import NewsfeedList from './Pages/Newsfeed/NewsfeedList';
import NewsfeedDetail from './Pages/Newsfeed/NewsfeedDetail';
import NewsfeedCreate from './Pages/Newsfeed/NewsfeedCreate';
import NewsFeedView from './Pages/Newsfeed/NewsFeedView';
import DonationDetail from './Pages/Donations/internal/DonationDetail';
import UserDetail from './Pages/Users/UserDetail';
import UserCreate from './Pages/Users/UserCreate';
import IntroductionList from './Pages/Users/IntroOfWoman/IntroductionList';
import IntroductionDetail from './Pages/Users/IntroOfWoman/IntroductionDetail';
import IntroductionForm from './Pages/Users/IntroOfWoman/IntroductionForm';
import SideDrawer from './Drawer';
import { styled } from '@mui/material/styles';
import SPDChapterDetail from './Pages/Chapters/SPDChapter/SPDChapterDetail';
import LCDetail from './Pages/Chapters/LocalChapter/LCDetail';
import Report from './Pages/Reports/Report';
import { getMe } from './endpoints/login';
import { jwtDecode } from 'jwt-decode';
import { useApiGet } from './utils/httpClient';
import TLCDetail from './Pages/TLC/TLCDetail';
import BnBDetail from './Pages/BedAndBreakfast/BnBDetail';
import Cottey from './Pages/Projects/Cottey';
import IntlDetail from './Pages/Chapters/International/InternationalDetail';
import FeedbackCreate from './Pages/Feedback/ContactUs';
import SeekingTransferList from './Pages/Users/SeekingTransfer/SeekingTransferList';
import SeekingTransferDetail from './Pages/Users/SeekingTransfer/SeekingTransferDetail';
import SeekingTransferCreate from './Pages/Users/SeekingTransfer/SeekingTransferCreate';
import ConversationDetail from './Pages/Message/ConversationDetail';
import DocumentLibrary from './Pages/Library/DocumentLibrary';
import DocumentManager from './Pages/Library/DocumentManager';
import DocumentView from './Pages/Library/DocumentView';
import DocumentVersionDetail from './Pages/Library/DocumentVersionDetail';
import DocumentCreate from './Pages/Library/DocumentCreate';
import DocumentEdit from './Pages/Library/DocumentEdit';
import DocumentBundle from './Pages/Library/DocumentBundle';
import GroupPermissions from './Pages/Library/GroupPermissions';
import LeadershipDevelopment from './Pages/LDC/LeadershipDevelopment';
import Map from './Pages/Maps/Map';
import { config } from './utils/config';
import AnnualReportsDashboard from './Pages/AnnualReports/AnnualReportsDashboard';
import Prework from './Pages/AnnualReports/Prework';
import RosterDues from './Pages/AnnualReports/RosterDues';
import IRSForms from './Pages/AnnualReports/IRSForms';
import ARResources from './Pages/AnnualReports/Resources';
import ARTraining from './Pages/AnnualReports/Training';
import SPDPreworkForm from './Pages/AnnualReports/Prework/SPDPreworkForm';
import SPDPreworkList from './Pages/AnnualReports/Prework/SPDPreworkList';
import PEOReportsList from './Pages/PEOReports/PEOReportsList';
import PEOReportDetail from './Pages/PEOReports/PEOReportDetail';

const PrivateRoutes = () => {
  let auth = localStorage.getItem('user_id');
  return auth ? <Outlet /> : <Navigate to="/login" />;
};

const MessageAdmin = () => {
  let apps = localStorage.getItem('apps');
  if (!apps) return false;
  let messageUsers = [applications.MessageAdmin, applications.MessageApprover];
  return messageUsers.some((app) => apps.includes(app)) ? (
    <Outlet />
  ) : (
    <Navigate to="/" />
  );
};

const IsNewsfeedAdmin = () => {
  let apps = localStorage.getItem('apps');
  if (!apps) return false;
  let allowed = apps.includes(applications.NewsfeedAdmin);
  return allowed ? <Outlet /> : <Navigate to="/" />;
};

const IsDocumentAdmin = () => {
  let apps = localStorage.getItem('apps');
  if (!apps) return false;
  let allowed = apps.includes(applications.DocumentAdmin);
  return allowed ? <Outlet /> : <Navigate to="/" />;
};

const IsAnnualReportsUser = () => {
  let role = localStorage.getItem('role');
  const allowedRoles = [
    '04a1d0a6f0884bcfb44911c2eaa5b77f', // Support
    '21160e65fd7243c49023aad41be8b084', // Finance
    '2ed5b967133e41febd61998477e018bb', // SPDOfficer
    '6b128d199aa04f99b362cff974958550', // RMR
    '785238dd501e4544b3970f742b19b04a', // Admin
    '81f985be6ef242018e17d574b3ab7c36', // LCOfficer
    '8cf288415fa24a2b9a23ab768db43533', // Executive
    'f8d3d9db43ca49aea716df742adffd02', // Communications
  ];
  return allowedRoles.includes(role) ? <Outlet /> : <Navigate to="/" />;
};

const loggedIn = localStorage.getItem('user_id');

const drawerWidth = 300;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: 0,
    variants: [
      {
        props: ({ open }) => open,
        style: {
          transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
          }),
          marginLeft: `${drawerWidth}px`,
        },
      },
    ],
  })
);

const isMobile = window.innerWidth <= 768;

const Router = () => {
  const { data } = useApiGet(['refresh'], getMe, {
    enabled: localStorage.getItem('user_id') ? true : false,
    retry: 0,
    refetchInterval: 60 * 60000, // The data will be refetched every 60 minutes
  });
  const [open, setOpen] = useState(true);
  const handleUpdateDrawer = () => {
    setOpen(!open);
  };

  useEffect(() => {
    if (data) {
      localStorage.setItem('token', data.access_token);
      const decoded = jwtDecode(data.access_token);
      localStorage.setItem('user_id', decoded.sub);
      localStorage.setItem('first_name', decoded.first_name);
      localStorage.setItem('last_name', decoded.last_name);
      localStorage.setItem('apps', decoded.applications);
      localStorage.setItem('role', decoded.role);
    }
  }, [data]);

  const routes = (
    <Routes>
      <Route element={<PrivateRoutes />}>
        <Route path="/roster" element={<Roster />} />
        <Route path="/roster/:id" element={<RosterDetail />} />
        <Route path="/irs" element={<Irs />} />
        <Route path="/reports" element={<Report />} />
        {config.NEW_REPORTS_ENABLED && (
          <>
            <Route path="/peo-reports" element={<PEOReportsList />} />
            <Route path="/peo-reports/:id" element={<PEOReportDetail />} />
          </>
        )}
        <Route path="/irs/:id" element={<IrsDetail />} />
        <Route path="/training" element={<Training />} />
        <Route path="/training/:id" element={<TrainingDetail />} />
        <Route path="/training/create" element={<TrainingCreate />} />
        <Route path="/documents" element={<Documents />} />
        <Route element={<IsDocumentAdmin />}>
          <Route path="/library/create" element={<DocumentCreate />} />
          <Route
            path="/library/:id/versions"
            element={<DocumentVersionDetail />}
          />
          <Route
            path="/library/:id/versions/:versionId"
            element={<DocumentVersionDetail />}
          />
          <Route path="/library/:id/edit" element={<DocumentEdit />} />
          <Route path="/library/manager" element={<DocumentManager />} />
          <Route
            path="/library/group-permissions"
            element={<GroupPermissions />}
          />
        </Route>
        <Route path="/library/:id/view/:versionId" element={<DocumentView />} />
        <Route path="/library/bundles/:bundleId" element={<DocumentBundle />} />
        <Route path="/library" element={<DocumentLibrary />} />
        <Route path="/release-notes" element={<ReleaseNotes />} />
        <Route path="/" element={<Dashboard />} />
        <Route path="/local-chapters" element={<LCChapterList />} />
        <Route path="/local-chapters/:id" element={<LCDetail />} />
        <Route path="/spd-chapters" element={<SPDChapterList />} />
        <Route path="/spd-chapters/:id" element={<SPDChapterDetail />} />
        <Route path="/international" element={<IntlDetail />} />
        <Route path="/bnb" element={<BnBList />} />
        <Route path="/bnb/create" element={<BnBCreate />} />
        <Route path="/bnb/:id" element={<BnBDetail />} />
        <Route path="/internal/donations" element={<DonationsList />} />
        <Route path="/internal/donations/:id" element={<DonationDetail />} />

        <Route
          path="/leadership-development"
          element={<LeadershipDevelopment />}
        />
        <Route path="/tlc" element={<TLCList />} />
        <Route path="/tlc/:id" element={<TLCDetail />} />
        <Route path="/user" element={<UserList />} />
        <Route path="/user/:id" element={<UserDetail />} />
        <Route path="/user/create" element={<UserCreate />} />
        <Route path="/introductions" element={<IntroductionList />} />
        <Route path="/introductions/:id" element={<IntroductionDetail />} />
        <Route path="/introductions/create" element={<IntroductionForm />} />
        <Route path="/reciprocity" element={<ReciprocityList />} />
        <Route path="/reciprocity/:id" element={<ReciprocityDetail />} />
        <Route path="/projects/elf" element={<ELFLanding />} />
        <Route path="/projects/star" element={<StarLandingPage />} />
        <Route path="/projects/pce" element={<PCELandingPage />} />
        <Route path="/projects/psa" element={<PSALandingPage />} />
        <Route path="/projects/ips" element={<IPSLandingPage />} />
        <Route element={<IsNewsfeedAdmin />}>
          <Route path="/newsfeed" element={<NewsfeedList />} />
          <Route path="/newsfeed/:id" element={<NewsfeedDetail />} />
          <Route path="/newsfeed/create" element={<NewsfeedCreate />} />
        </Route>
        <Route path="/newsfeed/view/:id" element={<NewsFeedView />} />
        {config.SEEKING_TRANSFER_ENABLED && (
          <>
            <Route path="/seeking-transfer" element={<SeekingTransferList />} />
            <Route
              path="/seeking-transfer/:id"
              element={<SeekingTransferDetail />}
            />
            <Route
              path="/seeking-transfer/create/:userId"
              element={<SeekingTransferCreate />}
            />
          </>
        )}
        <Route path="/foundation" element={<FoundationLandingPage />} />
        <Route path="/cottey" element={<Cottey />} />
        <Route path="/marketplace" element={<MarketplaceList />} />
        <Route path="/marketplace/:id" element={<MarketplaceDetail />} />
        <Route path="/marketplace/create" element={<MarketplaceCreate />} />
        <Route path="/marketplace/:id/edit" element={<MarketplaceEdit />} />
        <Route element={<MessageAdmin />}></Route>
        <Route path="/conversations" element={<Conversations />} />
        <Route path="/conversations/:id" element={<ConversationDetail />} />
        <Route path="/feedback/create" element={<FeedbackCreate />} />
        <Route path="/map" element={<Map />} />

        <Route element={<IsAnnualReportsUser />}>
          <Route path="/annual-reports" element={<AnnualReportsDashboard />} />
          <Route path="/annual-reports/prework" element={<Prework />} />
          <Route
            path="/annual-reports/prework/spd"
            element={<SPDPreworkList />}
          />
          <Route path="/prework/spd/:id" element={<SPDPreworkForm />} />
          <Route
            path="/annual-reports/prework/spd/:id"
            element={<SPDPreworkForm />}
          />
          <Route
            path="/annual-reports/prework/spd-dues/:id"
            element={<SPDPreworkForm />}
          />
          <Route path="/annual-reports/roster-dues" element={<RosterDues />} />
          <Route path="/annual-reports/irs-forms" element={<IRSForms />} />
          <Route path="/annual-reports/resources" element={<ARResources />} />
          <Route path="/annual-reports/training" element={<ARTraining />} />
        </Route>
      </Route>
      <Route path="*" element={<NotFound />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route path="/donations" element={<Donations />} />
    </Routes>
  );
  return (
    <BrowserRouter>
      <Grid sx={{ position: 'relative', minHeight: '100vh' }}>
        {loggedIn && (
          <SideDrawer
            open={open}
            isMobile={isMobile}
            handleUpdateDrawer={handleUpdateDrawer}
            drawerWidth={drawerWidth}
          />
        )}
        {isMobile ? (
          <Grid item xs={12} paddingBottom={12}>
            {routes}
          </Grid>
        ) : (
          <Grid item xs={12} paddingBottom={11}>
            {loggedIn ? (
              <Main open={open}>{routes}</Main>
            ) : (
              <React.Fragment>{routes}</React.Fragment>
            )}
          </Grid>
        )}
      </Grid>
      {loggedIn && (
        <Grid item xs={12}>
          <Footer />
        </Grid>
      )}
    </BrowserRouter>
  );
};

export default Router;
